// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aixEx","content":"styles_content__3-yDA"};